<template>
    <nav class="partitionNav ms-md-3 mx-0 p-2">

        <div class="row justify-content-between">
            <div class="col-9">
                <ReportFilters :reportType="reportType" :reportName="reportName"></ReportFilters>
            </div>
            <div class="col-3">
                <div class="row">
                    <div v-if="showPartition" class="col-6">
                        <div style="float: right">
                            <div>Type</div>
                            <div class="date-range-picker-wrap mt-0" style="float: right;">
                                <div class="dropdown">
                                    <button class="btn btn-sm btn-outline-primary dropdown-toggle text-capitalize" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ partition }}
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                        <li class="nav-item" :class="{ active: partition === 'hourly' }" @click.prevent="partitionChanged('hourly')">
                                            <a href="#" class="nav-link">Hourly</a>
                                        </li>
                                        <li class="nav-item" :class="{ active: partition === 'daily' }" @click.prevent="partitionChanged('daily')">
                                            <a href="#" class="nav-link">Daily</a>
                                        </li>
                                        <li class="nav-item" :class="{ active: partition === 'weekly' }" @click.prevent="partitionChanged('weekly')">
                                            <a href="#" class="nav-link">Weekly</a>
                                        </li>
                                        <li class="nav-item" :class="{ active: partition === 'monthly' }" @click.prevent="partitionChanged('monthly')">
                                            <a href="#" class="nav-link">Monthly</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div style="float: right">
                            <div>Date</div>
                            <div class="date-range-picker-wrap mt-0" style="float: right;" v-click-outside="closeDatePicker">
                                <!-- F-07: monthly partition uses a Month-Year picker instead of the day range -->
                                <input v-if="partition === 'monthly'"
                                   type="month"
                                   class="month-picker"
                                   v-model="selectedMonth"
                                   :max="currentMonth"
                                   @change="onMonthChanged" />
                                <v-date-picker v-if="partition !== 'monthly'" class="date-range-picker" v-show="selectedRange.tag === 'custom'"
                                   :input-props="{ style: `
                                            background-color: #ffffff;
                                            color: #3D3B30;
                                            padding: 0.5rem;
                                            border-radius: 0.25rem;
                                            margin: 0.1rem 0;
                                            width: 200px;
                                            text-align: center;
                                            cursor: pointer;
                                        `
                                    }"
                                   is-range
                                   :max-date="new Date()"
                                   v-model="range"
                                   @input="onCustomDateRangeChanged">
                                </v-date-picker>

                                <div class="dropdown" v-if="partition !== 'monthly'">
                                    <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ selectedRange.title }}
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                        <li>
                                            <a href="#" class="dropdown-item"
                                               v-for="item in rangeSelections" @click="changeSelectedRange(item)">
                                                {{ item.title }}
                                            </a>
                                            <a href="#" class="dropdown-item"
                                               @click="changeSelectedRange({ tag: 'custom', title: 'Custom' })">
                                                Custom
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </nav>
</template>

<script>
import moment from 'moment';
import ReportContainer from './ReportContainer';
import ReportSideBar from "../../components/reports/ReportSideBar";
import ReportFilters from "../../pages/Reports/filters/ReportFilters";
import OEEChart from '../../components/reports/OEEChart';
import ReportTableOEEByStation from './reporttable/oee/ReportTableOEEByStation';
import ReportTableOEEByProduct from './reporttable/oee/ReportTableOEEByProduct';
import ReportTableOEEByShift from './reporttable/oee/ReportTableOEEByShift';
import ReportTableOEEByOperator from './reporttable/oee/ReportTableOEEByOperator';
import ReportTableOEEByTeam from './reporttable/oee/ReportTableOEEByTeam';

export default {
    name: "ReportsCommonHeader",
    components: {
        ReportSideBar,
        ReportContainer,
        ReportFilters,
        'oee-chart': OEEChart,
        'report-table-by-station': ReportTableOEEByStation,
        'report-table-by-product': ReportTableOEEByProduct,
        'report-table-by-shift': ReportTableOEEByShift,
        'report-table-by-operator': ReportTableOEEByOperator,
        'report-table-by-team': ReportTableOEEByTeam,
    },
    props: {
        reportName: {
            type: String,
            default: 'oee',
        },
        showPartition: {
            type: Boolean,
            default: true
        },
        reportType: {
            type: String,
            default: 'station'
        }
    },
    data: () => ({
        selectedRange: {
            tag: 'today',
            title: 'Today'
        },
        partition: 'hourly',
        selectedMonth: moment().format('YYYY-MM'),
        range: {
            start: moment().startOf('day').toDate(),
            end: moment().endOf('day').toDate()
        },
        selectedRangeX: {
            start: moment().startOf('day').toDate(),
            end: moment().endOf('day').toDate()
        },
        selectedPartition: 'hourly',
        selectedReportType: 'station',
        selectedStationId: 0,
        selectedStation: null,
        selectedStationProductId: 0,
        selectedStationProduct: null,
        selectedStationShiftId: 0,
        selectedStationShift: null,
        selectedStationOperatorId: 0,
        selectedStationOperator: null,
        selectedStationTeamId: 0,
        selectedStationTeam: null,
        title: '',
        dataset: {
            labels: [],
            performance: [],
            availability: [],
            quality: [],
            oee: [],
        },
        downtimeDataset: {
            labels: [],
            downtimes: []
        },
        tableData: []
    }),
    computed: {
        currentMonth() {
            return moment().format('YYYY-MM');
        },
        rangeSelections() {
            switch (this.partition) {
                case 'hourly':
                    return [
                        {
                            tag: 'today',
                            title: 'Today'
                        },
                        {
                            tag: 'yesterday',
                            title: 'Yesterday'
                        },
                        {
                            tag: 'this_week',
                            title: 'This Week'
                        },
                        {
                            tag: 'last_week',
                            title: 'Last Week'
                        }
                    ];

                case 'daily':
                    return [
                        {
                            tag: 'this_week',
                            title: 'This Week'
                        },
                        {
                            tag: 'last_week',
                            title: 'Last Week'
                        }
                    ]
            }
        },
        reportTableTitle(){
            if(this.selectedReportType === 'station'){
                if(this.selectedStationId){
                    if(this.selectedStation) return `Station: ${this.selectedStation.name}`;
                    return '';
                } else {
                    return 'All Stations';
                }
            } else if(this.selectedReportType === 'product'){
                if(this.selectedStationProductId){
                    if(this.selectedStationProduct) return `Station: ${this.selectedStationProduct.station_name} > Product: ${this.selectedStationProduct.product_name}`;
                    return '';
                } else {
                    return 'All Products';
                }
            } else if(this.selectedReportType === 'shift'){
                if(this.selectedStationShiftId){
                    if(this.selectedStationShift) return `Station: ${this.selectedStationShift.station_name} > Shift: ${this.selectedStationShift.shift_name}`;
                    return '';
                } else {
                    return 'All Shifts';
                }
            } else if(this.selectedReportType === 'operator'){
                if(this.selectedStationOperatorId){
                    if(this.selectedStationOperator) return `Station: ${this.selectedStationOperator.station_name} > Operator: ${this.selectedStationOperator.operator_name}`;
                    return '';
                } else {
                    return 'All Operators';
                }
            }  else if(this.selectedReportType === 'team'){
                if(this.selectedStationTeamId){
                    if(this.selectedStationTeam) return `Station: ${this.selectedStationTeam.station_name} > Team: ${this.selectedStationTeam.name}`;
                    return '';
                } else {
                    return 'All Team';
                }
            }
        }
    },
    directives: {
        clickOutside: {
            bind(el, binding, vnode) {
                el.clickOutsideEvent = function(event) {
                    // Check if the click was outside the element
                    if (!(el === event.target || el.contains(event.target))) {
                        // Call the method provided in the binding to close the date picker
                        vnode.context[binding.expression](event);
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unbind(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
            }
        }
    },
    methods: {
        closeDatePicker() {
            this.selectedRange.tag = '';
        },
        reportTitle(report) {
            switch (report) {
                case 'oee':
                    return 'OEE';
                case 'quality':
                    return 'Quality';
                case 'availability':
                    return 'Availability';
                case 'downtime':
                    return 'Downtime';
            }
        },
        adjustPartitionBasedOnDateRange(range) {
            const startDate = moment(range.start);
            const endDate = moment(range.end);
            const daysDifference = endDate.diff(startDate, 'days');
            if (this.partition === 'hourly') {
                if (daysDifference > 90) {
                    this.partition = 'monthly';
                    this.selectedPartition = 'monthly';
                    this.$emit('partitionSelected', 'monthly');
                } else if (daysDifference > 30) {
                    this.partition = 'weekly';
                    this.selectedPartition = 'weekly';
                    this.$emit('partitionSelected', 'weekly');
                } else if (daysDifference > 7) {
                    this.partition = 'daily';
                    this.selectedPartition = 'daily';
                    this.$emit('partitionSelected', 'daily');
                }
            } else if (this.partition === 'daily') {
                if (daysDifference > 90) {
                    this.partition = 'monthly';
                    this.selectedPartition = 'monthly';
                    this.$emit('partitionSelected', 'monthly');
                } else if (daysDifference > 30) {
                    this.partition = 'weekly';
                    this.selectedPartition = 'weekly';
                    this.$emit('partitionSelected', 'weekly');
                }
            } else if (this.partition === 'weekly') {
                if (daysDifference > 90) {
                    this.partition = 'monthly';
                    this.selectedPartition = 'monthly';
                    this.$emit('partitionSelected', 'monthly');
                }
            }
        },
        changeSelectedRange(item) {
            this.selectedRange = item;

            switch (item.tag) {
                case 'today':
                    this.range.start = moment().startOf('day').toDate();
                    this.range.end = moment().endOf('day').toDate();
                    break;

                case 'yesterday':
                    this.range.start = moment().subtract(1, "days").startOf('day').toDate();
                    this.range.end = moment().subtract(1, "days").endOf('day').toDate();
                    break;

                case 'this_week':
                    this.range.start = moment().startOf('week').toDate();
                    this.range.end = moment().endOf('week').toDate();
                    break;

                case 'last_week':
                    this.range.start = moment().startOf('week').subtract(7, "days").toDate();
                    this.range.end = moment().endOf('week').subtract(7, "days").toDate();
                    break;
            }
            this.onDateRangeChanged(this.range)
        },
        onDateRangeChanged(range) {
            this.$emit('rangeSelected', range);
        },
        onCustomDateRangeChanged(range) {
            this.adjustPartitionBasedOnDateRange(range);
            this.$emit('rangeSelected', range);
            this.selectedRange.tag = "";
        },
        partitionChanged(p){
            this.partition = p;
            this.selectedPartition = p;
            // this.fetchOEEData();
            this.$emit('partitionSelected', p);
            // F-07: when switching to monthly, drive the range from the
            // month picker (start-of-month .. end-of-month) so the report
            // matches the Month-Year control rather than the leftover day range.
            if (p === 'monthly') {
                this.onMonthChanged();
            }
        },
        // F-07: map the selected YYYY-MM to a full-month range and emit it.
        onMonthChanged() {
            if (!this.selectedMonth) {
                return;
            }
            const start = moment(this.selectedMonth, 'YYYY-MM').startOf('month').toDate();
            const end   = moment(this.selectedMonth, 'YYYY-MM').endOf('month').toDate();
            this.range.start = start;
            this.range.end   = end;
            this.$emit('rangeSelected', { start, end });
        },
        onPartitionSelect(eventData) {
            this.selectedPartition = eventData;
            this.fetchOEEData();
        },
        onRangeSelect(eventData) {
            this.selectedRange.start = eventData.start;
            this.selectedRange.end = eventData.end;
            this.fetchOEEData();
        },
        changeReportType(type) {
            this.reportType = type;
            this.selectedReportType = type;
            this.fetchOEEData();
        },
        onReportTypeChange(eventData) {
            this.selectedReportType = eventData;
            this.fetchOEEData();
        },
    },
}
</script>

<style scoped>
.date-range-picker.vc-container.vc-blue{
    cursor: pointer;
    position: absolute;
    right: 7em;
    top: .5em;
    z-index: 9999;
}
.partition-picker {
    flex-direction: row !important;
    justify-content: space-between !important;
}
.partition-picker li a {
    padding: .85em;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}
.partitionNav {
    background-color: #b7e4ff;
}
.month-picker {
    background-color: #ffffff;
    color: #3D3B30;
    padding: 0.4rem 0.5rem;
    border-radius: 0.25rem;
    margin: 0.1rem 0;
    width: 180px;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    border: 1px solid #ccc;
    float: right;
}
</style>

